module.exports = __webpack_public_path__ + "static/media/falling_star_white.f196c4f3.svg";